<template>
  <div
    :class="[
      'relative grid items-center rounded-lg px-1.5 py-0.5',
      isHighlighted ? ` ? bg-color-${color}-light` : '',
      icon ? iconColumn[size] : 'grid-cols-1',
      gapCozy[size],
      isClickable ? 'cursor-pointer' : '',
      badge ? 'pe-5' : '',
    ]"
  >
    <div
      v-if="badge && isHighlighted"
      class="absolute -top-1.5 -right-1.5 z-10 center-xy rounded-full h-(--icon-size-small) w-(--icon-size-small) text-tiny color-light"
      :class="`bg-color-${color}-dark`"
    >
      {{ badge }}
    </div>
    <i v-if="icon" :class="[`ti ti-${icon}`, `color-${color}`, emphasisFont[size]]"></i>
    <div class="min-w-0">
      <div v-if="label" class="card-info-label">
        {{ label }}
      </div>
      <div class="text-xxs truncate pe-2" :class="isHighlighted ? 'color-tertiary' : 'color-text'">
        {{ value }}
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { EMPHASIS_FONT, GAP_COZY } from "@/constants/sizing";
import { ComponentColorType, ComponentSizeType } from "@/types/componentType";
import { PropType, defineComponent } from "vue";

const ICON_COLUMN: Record<ComponentSizeType, string> = {
  small: "grid-cols-[var(--control-icon-small)_1fr]",
  default: "grid-cols-[var(--control-icon-default)_1fr]",
  large: "grid-cols-[var(--control-icon-large)_1fr]",
};

export default defineComponent({
  name: "CardInfoField",
  props: {
    icon: { type: String, default: "" },
    label: { type: String, default: "" },
    value: { type: String, default: "" },
    badge: { type: [Number, String], default: null },
    color: { type: String as PropType<ComponentColorType>, default: "medium" },
    size: { type: String as PropType<ComponentSizeType>, default: "default" },
    isHighlighted: { type: Boolean, default: false },
    isClickable: { type: Boolean, default: false },
  },
  setup() {
    return { emphasisFont: EMPHASIS_FONT, gapCozy: GAP_COZY, iconColumn: ICON_COLUMN };
  },
});
</script>
